import React, { useEffect, useState } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/FullWidthWithImage.js";
import MainFeature from "components/features/TwoColSingleFeatureWithStats.js";
import SliderCard from "components/cards/JobsThreeColSlider.js";
import Blog from "components/blogs/PopularAndRecentBlogPosts.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import FAQ from "components/faqs/SimpleWithSideImage.js";
import SubscribeNewsLetterForm from "components/forms/SimpleSubscribeNewsletter.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import { getJobs } from "api/jobs";
import { Helmet } from "react-helmet-async";

export default function JobLandingPage () {
  const [jobs, setJobs] = useState(null)

  useEffect(() => {
    getJobs().then(data => {
      if (data) {
        setJobs(data);
      }
    }).catch(error => {
      console.error("Error fetching jobs:", error);
    });
  }, [])
  

  return (
    <>
    <Helmet>
      <title>Career | Placement & Business Services Ltd</title>
      <meta
        name="description"
        content="Explore exciting career opportunities with us."
      />

      <link rel="canonical" href="https://www.pbslja.com/jobs" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "JobsPage",
          "name": "Jobs",
          "url": "https://www.pbslja.com/jobs",
          "description": "Explore exciting career opportunities with us.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.pbslja.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Jobs",
                "item": "https://www.pbslja.com/jobs"
              }
            ]
          }
        })}
      </script>
    </Helmet>
    <AnimationRevealPage>
      <Hero />
      <SliderCard jobs={jobs} />
      {/* <MainFeature /> */}
      {/* <Blog /> */}
      {/* <Testimonial textOnLeft={true}/>
      <FAQ />
      <SubscribeNewsLetterForm /> */}
      <Footer />
    </AnimationRevealPage>
    </>
)};
